import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {Result} from "@vesta/error-handling-remix/result";
import {
    DULUX__EVENT__APPOINTMENT__SCHEDULE_DATE__COLUMN_ID,
    DULUX__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID,
} from "~/domainModels/workspaceSpecific/dulux";
import {
    duluxDisposeAction,
    type DuluxActionResponse,
} from "~/utilities/apis/duluxActionsApi";
import type {EventWithEventContainer} from "~/utilities/apis/api";
import {duluxScheduleRawToApiString} from "~/utilities/eventContainerTriggerEvent";

export type DuluxJourneyDisposeSubmitArgs = {
    accessToken: string;
    dispositionId: Uuid;
    event: EventWithEventContainer;
    intellsysBaseUrl: string;
    remarks: string | null;
    triggerEventAdditionalColumnValues?: Record<Uuid, unknown>;
    workspaceId: Uuid;
};

function readOptionalDuluxScheduleIso(
    additionalColumnValues: Record<Uuid, unknown> | undefined,
    columnId: Uuid,
): Iso8601DateTime | null {
    if (additionalColumnValues === undefined) {
        return null;
    }
    const raw = additionalColumnValues[columnId];
    if (raw === null || raw === undefined || raw === "") {
        return null;
    }
    return duluxScheduleRawToApiString(raw);
}

export function submitDuluxJourneyDispose(
    args: DuluxJourneyDisposeSubmitArgs,
): Promise<Result<DuluxActionResponse>> {
    return duluxDisposeAction({
        accessToken: args.accessToken,
        intellsysBaseUrl: args.intellsysBaseUrl,
        request: {
            workspaceId: args.workspaceId,
            eventContainerId: args.event.eventContainer.id,
            dispositionId: args.dispositionId,
            remarks: args.remarks,
            scheduledCallOnIso: readOptionalDuluxScheduleIso(
                args.triggerEventAdditionalColumnValues,
                DULUX__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID,
            ),
            scheduledAppointmentOnIso: readOptionalDuluxScheduleIso(
                args.triggerEventAdditionalColumnValues,
                DULUX__EVENT__APPOINTMENT__SCHEDULE_DATE__COLUMN_ID,
            ),
        },
    });
}
